var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1349_4496)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5518 0.227378L25.3704 2.40882C25.2258 2.55344 25.1445 2.74963 25.1445 2.95413V6.63644L28.8683 1.79138V0.772691C28.8683 0.0856909 28.0377 -0.258372 27.5518 0.227378Z",
    fill: "#AD4F3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.227 3.13184H30.2083L25.3633 6.85565H29.0456C29.2502 6.85565 29.4463 6.7744 29.5909 6.62977L31.7723 4.44834C32.2581 3.96252 31.914 3.13184 31.227 3.13184Z",
    fill: "#AD4F3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9114 31.9996C6.68925 31.9996 0 25.3103 0 17.0881C0 8.86595 6.68925 2.17676 14.9114 2.17676C23.1336 2.17676 29.8229 8.86601 29.8229 17.0882C29.8229 25.3104 23.1336 31.9996 14.9114 31.9996Z",
    fill: "#DCDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9114 28.8404C8.43118 28.8404 3.15918 23.5684 3.15918 17.0882C3.15918 10.608 8.43112 5.33594 14.9114 5.33594C21.3916 5.33594 26.6636 10.6079 26.6636 17.0881C26.6636 23.5683 21.3915 28.8404 14.9114 28.8404Z",
    fill: "#506366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9114 25.6821C10.1732 25.6821 6.31836 21.8273 6.31836 17.0891C6.31836 12.3509 10.1732 8.49609 14.9114 8.49609C19.6495 8.49609 23.5044 12.3509 23.5044 17.0891C23.5044 21.8272 19.6495 25.6821 14.9114 25.6821Z",
    fill: "#6EE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9114 22.5219C11.9152 22.5219 9.47754 20.0843 9.47754 17.0881C9.47754 14.0919 11.9152 11.6543 14.9114 11.6543C17.9075 11.6543 20.3452 14.0919 20.3452 17.0881C20.3452 20.0844 17.9075 22.5219 14.9114 22.5219Z",
    fill: "#FD6F71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9115 19.364C16.1678 19.364 17.1862 18.3455 17.1862 17.0892C17.1862 15.8329 16.1678 14.8145 14.9115 14.8145C13.6552 14.8145 12.6367 15.8329 12.6367 17.0892C12.6367 18.3455 13.6552 19.364 14.9115 19.364Z",
    fill: "#FADC60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9113 15.7479C14.5413 16.118 14.5413 16.7181 14.9113 17.0882C15.2814 17.4583 15.8816 17.4583 16.2516 17.0882L30.2085 3.13133L28.8682 1.79102L14.9113 15.7479Z",
    fill: "#C86D5C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1349_4496"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoal);
export default __webpack_public_path__ + "static/media/goal.446a14a6f626c7288e04b0f79def5f07.svg";
export { ForwardRef as ReactComponent };